import { supabase } from "../supabase";

/** Fetch the audit log for a tree (most recent first). */
export async function fetchAuditLog(treeId, limit = 100) {
  const { data, error } = await supabase
    .from("audit_log")
    .select("*, user:user_id(full_name, initials)")
    .eq("tree_id", treeId)
    .order("created_at", { ascending: false })
    .limit(limit);
  return { log: data ?? [], error };
}

/** Record a mutation in the audit log. Called by the store actions. */
export async function recordAuditEntry({ treeId, action, personId, personName, fields }) {
  const { error } = await supabase.rpc("record_audit_entry", {
    p_tree_id: treeId,
    p_action: action,
    p_person_id: personId ?? null,
    p_person_name: personName,
    p_fields: fields ?? null,
  });
  return { error };
}
